// ---------------------------------------------------------------
// guideService.js — Guía rápida: enlaces de interés y teléfonos de
// emergencia para los días de guardia. Documento único
// `guideConfig/main` { links: [{title,url,desc}], phones:
// [{name,number,desc}] }. Lo leen todos; sólo el admin lo edita.
// ---------------------------------------------------------------
import { doc, onSnapshot, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../firebase";

// Teléfonos precargados (el admin puede editarlos o añadir más,
// p. ej. completar el del Colegio de Farmacéuticos de Alicante).
export const DEFAULT_PHONES = [
  {
    name: "Emergencias",
    number: "112",
    desc: "Número único de emergencias: accidentes, incendios, urgencias médicas graves… Gratuito y 24 h; coordina policía, bomberos y ambulancias.",
  },
  {
    name: "Urgencias sanitarias / Ambulancia",
    number: "061",
    desc: "Emergencias médicas y solicitud de ambulancia cuando el paciente necesita atención urgente.",
  },
  {
    name: "Policía Nacional",
    number: "091",
    desc: "Robos, altercados o situaciones de inseguridad en la farmacia durante la guardia.",
  },
  {
    name: "Policía Local",
    number: "092",
    desc: "Incidencias locales: problemas en la vía pública, ruidos, apoyo cercano.",
  },
  {
    name: "Guardia Civil",
    number: "062",
    desc: "Emergencias y seguridad ciudadana fuera del casco urbano.",
  },
  {
    name: "Bomberos",
    number: "080",
    desc: "Incendios, escapes de gas, inundaciones o rescates.",
  },
  {
    name: "Instituto Nacional de Toxicología",
    number: "915 620 420",
    desc: "Consultas por intoxicaciones, sobredosis o ingestión accidental de medicamentos. Atiende 24 h.",
  },
  {
    name: "Violencia de género",
    number: "016",
    desc: "Atención a víctimas de violencia de género. No deja rastro en la factura del teléfono.",
  },
  {
    name: "Atención a la conducta suicida",
    number: "024",
    desc: "Línea de ayuda a personas con ideación suicida y a sus allegados, 24 h.",
  },
  {
    name: "Colegio de Farmacéuticos de Alicante",
    number: "",
    desc: "Consultas colegiales, turnos de guardia y avisos oficiales. (Edita esta ficha para añadir su teléfono.)",
  },
];

export function subscribeGuide(onData, onError) {
  return onSnapshot(
    doc(db, "guideConfig", "main"),
    (snap) => onData(snap.exists() ? snap.data() : null),
    onError
  );
}

/** El admin guarda la guía completa (enlaces + teléfonos) */
export function saveGuide({ links, phones }) {
  return setDoc(
    doc(db, "guideConfig", "main"),
    { links, phones, updatedAt: serverTimestamp() },
    { merge: true }
  );
}
